// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2PPTt","choiceBoxes":"toolbarselects_choiceBoxes__Di32d","simpleField":"toolbarselects_simpleField__28J8I"};